export default "__VITE_ASSET__3E7AJ1Tq__"